var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 11,
    viewBox: "0 0 41 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.7271 5.5095L37.9669 0.020752L34.9238 10.9981L40.7271 5.5095Z",
    fill: "#008C44"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7893 5.5095L36.0322 0.020752L32.9844 10.9981L38.7893 5.5095Z",
    fill: "#F47920"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9902 10.9505H31.1708L34.2026 0H32.0221L28.9902 10.9505Z",
    fill: "#231F20"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3379 0.0336914C29.6539 0.0336914 29.8874 0.138558 30.0383 0.346579H30.0367C30.1875 0.554601 30.2178 0.819945 30.1288 1.13748L28.9139 5.52409C28.8297 5.83215 28.6502 6.08949 28.3802 6.2991C28.1086 6.50712 27.8211 6.61198 27.5147 6.61198H17.7076L16.4926 10.9969H14.3105L16.1211 4.46308H18.3001V4.46791H27.0255L27.6607 2.17777H16.7547L17.3486 0.0336914H29.3379Z",
    fill: "#231F20"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0747 10.9999C12.5257 10.9999 12.9195 10.6997 13.0402 10.2662L15.8831 0.0319824H13.7009L11.2488 8.85586H2.52016L4.9723 0.0319824H2.79008L0.0457121 9.91204C-0.0383761 10.2201 -0.00665968 10.479 0.142573 10.6871C0.293395 10.8951 0.520667 10.9999 0.827139 10.9999H12.0747Z",
    fill: "#231F20"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpi);
export default __webpack_public_path__ + "static/media/upi.eb7fad43213e1d76833dc52cc371e05a.svg";
export { ForwardRef as ReactComponent };